module.exports = __webpack_public_path__ + "static/media/incomplete1.37b5dd72.jpeg";